import { useEffect, useReducer, useRef, useState } from "react";
import "react-phone-number-input/style.css";
import { v4 as uuidv4 } from "uuid";
import { marked } from "marked";
import handelPreview from "./Api/handelPreview";
import {
  ChatHeader,
  ChatInput,
  ChatMessages,
  CVoiceRecorder,
  UserDetailsForm,
} from "./components";

import { Base64 } from "js-base64";

const initialState = {
  ques: "",
  loading: false,
  form_skip: false,
  templeteQuesClick: false,
  showtempuestions: false,
};

const reducer = (state, action) => ({
  ...state,
  [action.type]: action.payload,
});

function CView({
  cosui,
  botlogourl,
  userId,
  botID,
  reranking,
  queryexpanstion,
  templeteQues,
}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const textAreaRef = useRef(null);
  const containerRef = useRef(null);
  const isProcessing = useRef(false);

  const [isRecording, setIsRecording] = useState(false);
  const [savemessages, setSavemessages] = useState([]);
  const [load, setLoad] = useState(false);
  const [messages, setMessages] = useState([]);
  const [msgQueue, setMsgQueue] = useState([]);
  const [handlesubmenu, setHandelsubmenu] = useState(false);

  // Placeholder - ensure actual values are passed or managed by context/state
  const userdetails = { name: "User", email: "email@example.com" };
  const premsg = "";
  const phone = "";
  const botchatuid = useRef(uuidv4());
  const anskey = uuidv4();

  // Restore from localStorage
  useEffect(() => {
    if (!botID) return;
    const savedMessages = localStorage.getItem(botID);
    const parsedMessages = JSON.parse(savedMessages);
    if (Array.isArray(parsedMessages) && parsedMessages) {
      setMessages(parsedMessages);
      setSavemessages(parsedMessages);
      dispatch({ type: "showtempuestions", payload: false });
    } else {
      setMessages([
        {
          isbot: true,
          msgg: "Hi, How can we help you?",
          key: uuidv4(),
          loading: false,
        },
      ]);
      dispatch({ type: "showtempuestions", payload: true });
    }
  }, [botID]);

  // Save to localStorage whenever messages change
  useEffect(() => {
    if (botID && messages.length > 0) {
      localStorage.setItem(botID, JSON.stringify(messages));
    }
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages, botID]);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [state.ques]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = state.ques.trim();
    if (!trimmed) return;

    setMsgQueue((prev) => [...prev, { role: "user", content: trimmed }]);
    dispatch({ type: "ques", payload: "" });
  };

  const handleTemplateSubmit = (que) => {
    const trimmed = que.trim();
    if (!trimmed) return;

    setMsgQueue((prev) => [...prev, { role: "user", content: trimmed }]);
    dispatch({ type: "ques", payload: "" });
  };

  useEffect(() => {
    const processQueue = async () => {
      if (isProcessing.current || msgQueue.length === 0) return;
      let uid = anskey;

      isProcessing.current = true;
      const newMsg = msgQueue[0];

      const userMessage = {
        isbot: false,
        msgg: newMsg.content,
        key: uuidv4(),
        loading: false,
      };

      setMessages((prev) => [...prev, userMessage]);
      setSavemessages((prev) => [...prev, userMessage]);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_CHAT_API}/botquery/${userId}/${botID}?reranking=${reranking}&queryexpanstion=${queryexpanstion}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              que: newMsg.content,
              visitor_id: localStorage.getItem("visitor_id"),
              name: userdetails.name,
              email: userdetails.email,
              phone,
              premsg,
            }),
          }
        );

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        var result = "";

        const citation = response.headers.get("doc_keys");

        uid = response.headers.get("uid") || anskey;

        const citation_list = [];
        if (citation) {
          const decoded = JSON.parse(Base64.decode(citation));

          const seen = new Set();
          for (const item of decoded) {
            if (!seen.has(item.url)) {
              seen.add(item.url);
              if (item.sub_type === "web") {
                citation_list.push({ uri: item.url, type: item.file_type });
              } else if (cosui.refpdftext && item.sub_type === "s3") {
                const url = await handelPreview(item.url);
                citation_list.push({ uri: url, type: item.file_type });
              }
            }
          }
        }

        setMessages((prev) => [
          ...prev,
          {
            isbot: true,
            citation: citation_list,
            msgg: "",
            key: uid,
            loading: true,
            error: false,
          },
        ]);

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          result += decoder.decode(value);
          setMessages((prev) =>
            prev.map((msg) =>
              msg.key === uid
                ? {
                    ...msg,
                    msgg: marked.parse(result),
                    loading: false,
                    citation: citation_list,
                    error: false,
                  }
                : msg
            )
          );
        }

        setSavemessages((prev) => [
          ...prev,
          {
            isbot: true,
            msgg: result,
            key: uid,
            loading: false,
            citation: citation_list,
            error: false,
          },
        ]);

        if (uid) {
          const urii = `${process.env.REACT_APP_CHAT_API}/answer/${uid}`;
          const option = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ans: result }),
          };
          await fetch(urii, option);
        }
      } catch (error) {
        console.error("Error while processing queue:", error.message);

        let errorMessage = "Something went wrong. Please try again.";

        // Detect DNS/Internet errors
        if (
          error?.message?.includes("net::ERR_NAME_NOT_RESOLVED") ||
          error?.message?.includes("Failed to fetch")
        ) {
          errorMessage =
            "🔌 Unable to connect. Please check your internet connection.";
        } else if (
          error.name === "AbortError" ||
          error.message?.includes("timeout")
        ) {
          errorMessage = "⏱️ Request timed out. Please check your connection.";
        } else if (error.message?.includes("429")) {
          errorMessage = "📈 Rate limit reached. Please wait and try again.";
        } else if (error.message?.includes("5")) {
          errorMessage = "🔥 Server error. Please try again later.";
        }

        if (messages.find((msg) => msg.key === uid)) {
          setMessages((prev) => {
            return prev.map((msg) => {
              return msg.key === uid
                ? {
                    ...msg,
                    msgg: `Error occurred while processing your request : ${errorMessage} `,
                    loading: false,
                    error: true,
                  }
                : msg;
            });
          });

          setSavemessages((prev) => {
            return prev.map((msg) => {
              return msg.key === uid
                ? {
                    ...msg,
                    msgg: `Error occurred while processing your request : ${errorMessage} `,
                    loading: false,
                    error: true,
                  }
                : msg;
            });
          });
        } else {
          setMessages((prev) => [
            ...prev,
            {
              isbot: true,
              msgg: `Error occurred while processing your request : ${errorMessage} `,
              key: anskey,
              loading: false,
              error: true,
            },
          ]);
          setSavemessages((prev) => [
            ...prev,
            {
              isbot: true,
              msgg: `Error occurred while processing your request : ${errorMessage} `,
              key: anskey,
              loading: false,
              error: true,
            },
          ]);
        }
      } finally {
        isProcessing.current = false;
        setMsgQueue((prev) => prev.slice(1));
      }
    };

    if (msgQueue.length > 0 && !isProcessing.current) {
      processQueue();
    }
  }, [msgQueue]);

  const handleInputChange = (e) => {
    dispatch({ type: "ques", payload: e.target.value });
  };

  const handleTranscript = (value) => {
    dispatch({ type: "ques", payload: value });
  };

  const handelnewchats = () => {
    setMessages([]);
    setTimeout(() => {
      const introMsg = {
        isbot: true,
        msgg: "How can we help you?",
        key: botchatuid.current,
        loading: false,
      };
      setMessages([introMsg]);
      dispatch({ type: "showtempuestions", payload: true });
    }, 1000);
  };

  const handelRetry = async (e, msg) => {
    e.preventDefault();
    const { key } = msg;
    const index = messages.findIndex((m) => m.key === key);
    if (index !== -1) {
      const question = messages[index - 1].msgg;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_CHAT_API}/botquery/${userId}/${botID}?reranking=${reranking}&queryexpanstion=${queryexpanstion}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              que: question,
              visitor_id: localStorage.getItem("visitor_id"),
              name: userdetails.name,
              email: userdetails.email,
              phone,
              premsg,
            }),
          }
        );

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let result = "";

        setMessages((prev) =>
          prev.map((m, i) =>
            i === index ? { ...m, msgg: "", loading: true, error: false } : m
          )
        );

        const citation = response.headers.get("doc_keys");

        const citation_list = [];
        if (citation) {
          const decoded = JSON.parse(atob(citation));

          const seen = new Set();

          for (const item of decoded) {
            if (!seen.has(item.url)) {
              seen.add(item.url);
              if (item.sub_type === "web") {
                citation_list.push({ uri: item.url, type: item.file_type });
              } else if (cosui.refpdftext && item.sub_type === "s3") {
                const url = await handelPreview(item.url);
                citation_list.push({ uri: url, type: item.file_type });
              }
            }
          }
        }

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          result += decoder.decode(value);

          setMessages((prev) =>
            prev.map((m, i) =>
              i === index
                ? {
                    ...m,
                    msgg: marked.parse(result),
                    loading: false,
                    citation: citation_list,
                    error: false,
                  }
                : m
            )
          );
        }

        setSavemessages((prev) =>
          prev.map((m, i) =>
            i === index
              ? {
                  ...m,
                  msgg: marked.parse(result),
                  loading: false,
                  citation: citation_list,
                  error: false,
                }
              : m
          )
        );

        if (key) {
          const urii = `${process.env.REACT_APP_JAANO_chat}/answer/${key}`;
          const option = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ans: result }),
          };
          await fetch(urii, option);
        }
      } catch (error) {
        console.error("Error while processing queue:", error);

        let errorMessage = "Something went wrong. Please try again.";

        // Detect DNS/Internet errors

        setMessages((prev) =>
          prev.map((msg) =>
            msg.key === key
              ? {
                  ...msg,
                  msgg: marked.parse(`⚠️ ${errorMessage}`),
                  loading: false,
                  error: true,
                }
              : msg
          )
        );

        setSavemessages((prev) =>
          prev.map((msg) =>
            msg.key === key
              ? {
                  ...msg,
                  msgg: marked.parse(`⚠️ ${errorMessage}`),
                  loading: false,
                  error: true,
                }
              : msg
          )
        );
      }
    }
  };

  const handelendchats = () => {
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          isbot: true,
          msgg: cosui.botgenthankyou,
          key: botchatuid.current,
          loading: false,
        },
      ]);
    }, 1000);
  };

  const handleDownload = () => {
    const transcript = localStorage.getItem(botID);
    if (!transcript) return;

    const parsed = JSON.parse(transcript);
    const content = parsed
      .map((msg) => `${msg.isbot ? "Bot" : "User"}: ${msg.msgg}`)
      .join("\n");

    const blob = new Blob([content], { type: "text/plain" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "chat_transcript.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };

  return (
    <div
      ref={containerRef}
      className="flex flex-1 min-h-full flex-col 2xl:text-base overflow-hidden sticky overflow-y-auto scroll-hidden">
      <ChatHeader
        containerRef={containerRef}
        handlesubmenu={handlesubmenu}
        setHandelsubmenu={setHandelsubmenu}
        handelnewchats={handelnewchats}
        handelendchats={handelendchats}
        handleDownload={handleDownload}
      />
      <ChatMessages
        savemessages={savemessages}
        messages={messages}
        botlogourl={botlogourl}
        cosui={cosui}
        show={state.showtempuestions}
        questions={templeteQues}
        dispatch={dispatch}
        handleTemplateSubmit={handleTemplateSubmit}
        handelRetry={handelRetry}
      />
      <ChatInput
        state={state}
        textAreaRef={textAreaRef}
        handleInputChange={handleInputChange}
        handelsubmit={handleSubmit}
        CVoiceRecorder={CVoiceRecorder}
        load={load}
        setLoad={setLoad}
        handleTranscript={handleTranscript}
        isRecording={isRecording}
        setIsRecording={setIsRecording}
      />
      <UserDetailsForm />
    </div>
  );
}

export default CView;
